/* tslint:disable */
/* eslint-disable */
/**
 * openapi.yml
 * オンラインCE API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CalcApResult,
} from '../models/index';
import {
    CalcApResultFromJSON,
    CalcApResultToJSON,
} from '../models/index';

export interface PostCalcapRequest {
    idToken: string;
    multipartFile: Blob;
}

/**
 * 
 */
export class CalcapApi extends runtime.BaseAPI {

    /**
     * A-Proof計算する
     */
    async postCalcapRaw(requestParameters: PostCalcapRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CalcApResult>> {
        if (requestParameters['idToken'] == null) {
            throw new runtime.RequiredError(
                'idToken',
                'Required parameter "idToken" was null or undefined when calling postCalcap().'
            );
        }

        if (requestParameters['multipartFile'] == null) {
            throw new runtime.RequiredError(
                'multipartFile',
                'Required parameter "multipartFile" was null or undefined when calling postCalcap().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['idToken'] != null) {
            formParams.append('idToken', requestParameters['idToken'] as any);
        }

        if (requestParameters['multipartFile'] != null) {
            formParams.append('multipartFile', requestParameters['multipartFile'] as any);
        }

        const response = await this.request({
            path: `/calcap`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CalcApResultFromJSON(jsonValue));
    }

    /**
     * A-Proof計算する
     */
    async postCalcap(requestParameters: PostCalcapRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CalcApResult> {
        const response = await this.postCalcapRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
